<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { supportedLocales } from '@/i18n'

defineProps<{
  modelValue: string
  dark?: boolean
  compact?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const { t } = useI18n({ useScope: 'global' })

function selectLocale(locale: string) {
  emit('update:modelValue', locale)
}
</script>

<template>
  <div
    :class="[
      'overflow-hidden rounded border',
      compact ? 'inline-flex' : 'flex w-full',
      dark ? 'border-tt-gray/25' : 'border-tt-light-gray'
    ]"
    role="radiogroup"
    :aria-label="t('settings.language')"
  >
    <button
      v-for="(locale, index) in supportedLocales"
      :key="locale"
      type="button"
      role="radio"
      :aria-checked="locale === modelValue"
      :class="[
        'flex-1 px-4 py-3 text-base transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-tt-green',
        index > 0 && (dark ? 'border-l border-tt-gray/25' : 'border-l border-tt-light-gray'),
        locale === modelValue
          ? dark
            ? 'bg-black/5 font-medium text-tt-gray'
            : 'bg-tt-lighter-gray font-medium text-tt-gray'
          : 'font-light text-tt-gray/70'
      ]"
      @click="selectLocale(locale)"
    >
      {{ t(`settings.${locale}`) }}
    </button>
  </div>
</template>
